import { Box, Typography } from '@mui/material';

const cardSx = {
    flex: '0 0 auto',
    minWidth: 128,
    borderRadius: '12px',
    px: 1.75,
    py: 1.1,
    color: '#fff',
    whiteSpace: 'nowrap',
    textAlign: 'right',
};

const labelSx = {
    fontSize: '0.68rem',
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    opacity: 0.9,
    lineHeight: 1.2,
};

const valueSx = {
    fontSize: '1.35rem',
    fontWeight: 700,
    lineHeight: 1.15,
    letterSpacing: '-0.02em',
    mt: 0.25,
};

export function GradientCard({ card, onClick }) {
    return (
        <Box
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={onClick ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onClick(event);
                }
            } : undefined}
            sx={{
                ...cardSx,
                background: card.gradient,
                boxShadow: card.shadow,
                cursor: onClick ? 'pointer' : 'default',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                '&:hover': onClick ? {
                    transform: 'translateY(-1px)',
                    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.18)',
                } : undefined,
            }}
        >
            <Typography sx={labelSx}>{card.label}</Typography>
            <Typography sx={valueSx}>{card.value}</Typography>
        </Box>
    );
}

export default GradientCard;
